import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .margin{background-color:var(--vscode-editorGutter-background)}";
n(css,{});
export { css, css as default };
